import { EpisodeOrderType } from '@diritto/common/episode/constants';
import { ContentEpisodesRelayResponseDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { QueryClient, QueryOptions, useQuery } from '@tanstack/react-query';
import { RelayEpisodeApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

export const useGetRelayContentNoticesQuery = ({
  contentId,
  queryOptions,
}: {
  contentId: number;
  queryOptions?: QueryOptions<ContentEpisodesRelayResponseDto>;
}) =>
  useQuery<ContentEpisodesRelayResponseDto>({
    queryKey: relayQueryKey.contentNoticeList(contentId, EpisodeOrderType.LastOrder),
    queryFn: () => RelayEpisodeApi.getContentNotices(contentId, EpisodeOrderType.LastOrder, { offset: 0, limit: 3 }),
    ...queryOptions,
  });

export const prefetchRelayContentNoticesQuery = async (queryClient: QueryClient, contentId: number) =>
  queryClient.prefetchQuery({
    queryKey: relayQueryKey.contentNoticeList(contentId, EpisodeOrderType.LastOrder),
    queryFn: () => RelayEpisodeApi.getContentNotices(contentId, EpisodeOrderType.LastOrder, { offset: 0, limit: 3 }),
    staleTime: 1000 * 60 * 60 * 24,
  });
